import { useQuery } from '@tanstack/react-query';
import { fetchMyIamPermissions, type KnownPermission } from '../services/iam';
import { useUser } from '../providers/UserProvider';
import { IAM_ME_KEY } from './queryKeys';

// Current user's IAM permissions (stored grants only), driving section gates
// and sidebar visibility. Gates must spinner (not redirect) while `isLoading`.
export function useMyPermissions() {
    const { isAuthenticated } = useUser();

    const query = useQuery({
        queryKey: IAM_ME_KEY,
        queryFn: fetchMyIamPermissions,
        enabled: isAuthenticated,
        staleTime: 60_000
    });

    const permissions = query.data;

    return {
        isLoading: !permissions && (query.isPending || !isAuthenticated),
        isError: query.isError,
        refetch: query.refetch,
        hasPermission: (permission: KnownPermission): boolean =>
            Boolean(permissions?.includes(permission))
    };
}
